import { useTranslation } from 'react-i18next';
import { setLanguage } from '@/i18n';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Globe, Check } from 'lucide-react';

export const LanguageSelectorNew = () => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language || 'en-US';

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    // Reload page to apply language changes everywhere
    window.location.reload();
  };

  const getFlag = () => {
    if (currentLang === 'pt-BR' || currentLang === 'pt') return '🇧🇷';
    return '🇺🇸';
  };

  const getCode = () => {
    if (currentLang === 'pt-BR' || currentLang === 'pt') return 'PT';
    return 'EN';
  };

  const getAriaLabel = () => {
    if (currentLang === 'pt-BR' || currentLang === 'pt') return 'Selecionar idioma';
    return 'Select language';
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="flex items-center gap-1 hover:bg-gray-100"
          data-testid="language-selector"
          aria-label={getAriaLabel()}
        >
          <Globe className="w-4 h-4" />
          <span>{getFlag()}</span>
          <span className="hidden sm:inline">{getCode()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem
          onClick={() => handleLanguageChange('pt-BR')}
          className="flex items-center justify-between cursor-pointer"
          data-testid="language-option-pt"
        >
          <span className="flex items-center gap-2">
            <span>🇧🇷</span>
            <span>Português (Brasil)</span>
          </span>
          {(currentLang === 'pt-BR' || currentLang === 'pt') && <Check className="w-4 h-4" />}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => handleLanguageChange('en-US')}
          className="flex items-center justify-between cursor-pointer"
          data-testid="language-option-en"
        >
          <span className="flex items-center gap-2">
            <span>🇺🇸</span>
            <span>English (US)</span>
          </span>
          {(currentLang === 'en-US' || currentLang === 'en') && <Check className="w-4 h-4" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelectorNew;
